<template>
  <Drawer
    :transfer="true"
    title="条件设置"
    v-model="visible"
    placement="right"
    class="condition_copyer"
    width="550px"
    :before-close="closeDrawer"
  >
    <div class="demo-drawer__content" v-if="visible">
      <select v-model="conditionConfig.priorityLevel" class="priority_level">
        <!-- 这里有个判断条件，条件设置优先级的时候，最后一个优先级是不会展示的，优先级最后不能设置，如果直接设置 length - 1 会报错 -->
        <option
          v-for="item in conditionsConfig.branchList.length > 0
            ? conditionsConfig.branchList.length - 1
            : conditionsConfig.branchList.length"
          :value="item"
          :key="item"
        >
          优先级{{ item }}
        </option>
      </select>
      <Form ref="conditionForm" :model="formData">
        <div>
          <!-- 或条件 -->
          <div v-for="(item, index) in formData.conditionsOr" :key="index">
            <!-- 且条件 -->
            <div>
              <Row v-for="(and, idx) in item" :key="idx" :gutter="24">
                <Col :span="7" class="andClass">
                  <FormItem
                    :prop="'conditionsOr.' + index + '.' + idx + '.keys'"
                    :rules="{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                    }"
                  >
                    <Select v-model="and.keys" @on-change="keyChange">
                      <Option
                        v-for="itemSelect in typeSelect"
                        :key="itemSelect.id"
                        :value="itemSelect.id"
                      >
                        {{ itemSelect.label }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :span="7" class="andClass">
                  <FormItem
                    :prop="'conditionsOr.' + index + '.' + idx + '.operator'"
                    :rules="{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                    }"
                  >
                    <Select v-model="and.operator">
                      <Option
                        v-for="itemType in conditionTypeConfig[and.type]"
                        :key="itemType.value"
                        :value="itemType.value"
                      >
                        {{ itemType.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col :span="7" class="andClass">
                  <FormItem
                    :prop="'conditionsOr.' + index + '.' + idx + '.value'"
                    :rules="{
                      trigger: 'blur',
                      validator: validatorValue
                    }"
                  >
                    <div v-if="showDomByType.includes(and.type)">
                      <InputNumber
                        v-if="and.type == 'number'"
                        v-model="and.value"
                        style="width: 100%"
                      />
                      <Select
                        v-if="
                          ['select', 'radio', 'checkbox'].includes(and.type)
                        "
                        v-model="and.value"
                        :multiple="
                          !(
                            and.operator == '==' ||
                            and.operator == '!=' ||
                            and.type == 'checkbox' ||
                            (and.type == 'select' && and.multiple == 'multiple')
                          )
                        "
                      >
                        <Option
                          v-for="itemValue in and.optionItems"
                          :key="itemValue.value"
                          :value="itemValue.value"
                        >
                          {{ itemValue.label }}
                        </Option>
                      </Select>
                      <DatePicker
                        v-if="and.type == 'date'"
                        v-model="and.value"
                        placeholder="值"
                        :type="and.dateType"
                        :format="and.dateFormat"
                        transfer
                      />
                      <TimePicker
                        v-if="and.type == 'time'"
                        v-model="and.value"
                        placeholder="值"
                        :type="and.type"
                        :format="and.dateFormat"
                        transfer
                      />
                    </div>
                    <Input v-else v-model="and.value" placeholder="值" />
                  </FormItem>
                </Col>
                <Col :span="3" class="andClass">
                  <Icon
                    type="md-close"
                    style="height: 32px; line-height: 32px; cursor: pointer;"
                    @click="deleteItem(and, index, idx)"
                  />
                </Col>
              </Row>
              <Button type="primary" icon="md-add" @click="addAnd(item, index)">
                且条件
              </Button>
            </div>
            <div v-if="index != formData.conditionsOr.length - 1">或</div>
          </div>
          <Button
            style="margin-top: 10px"
            type="primary"
            icon="md-add"
            @click="addOr"
          >
            或条件
          </Button>
        </div>
      </Form>
    </div>
    <div class="demo-drawer__footer clear">
      <Button @click="setCondition(false)">取 消</Button>
      <Button type="primary" @click="saveCondition">确 定</Button>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  conditionType,
  defaultTypeSelect,
  conditionTypeConfig
} from './drawerConfig';
import { validatorValue, getFormatConditionData } from './util';
import preload from '../../plugins/preload';
export default {
  components: {},
  data() {
    return {
      conditionType,
      typeSelect: [],
      conditionTypeConfig,
      conditionVisible: false,
      conditionsConfig: {
        branchList: []
      },
      conditionConfig: {},
      PriorityLevel: '',
      conditions: [],
      conditionList: [],
      checkedList: [],
      conditionRoleVisible: false,
      visible: false,
      showDomByType: ['number', 'select', 'radio', 'checkbox', 'time', 'date'],
      noShowConditionOption: [
        'time-range',
        'date-range',
        'picture-upload',
        'file-upload'
      ], // 不要的条件列表
      // 新增字段，上面的字段可能需要删除的
      // conditionsOr 或条件  options 且条件
      // 或条件里面 有选择的 项目，条件 值
      formData: {
        conditionsOr: [
          [
            {
              keys: '',
              operator: '',
              value: null,
              type: '',
              label: '',
              multiple: '',
              optionItems: [],
              dateType: '',
              dateFormat: ''
            }
          ]
        ]
      }
    };
  },
  computed: {
    ...mapState('workflow', [
      'tableId',
      'conditionsConfig1',
      'conditionDrawer',
      'permissionOption'
    ])
  },
  watch: {
    conditionsConfig1(val) {
      this.conditionsConfig = val.value;
      this.PriorityLevel = val.priorityLevel;
      this.conditionConfig = val.priorityLevel
        ? this.conditionsConfig.branchList[val.priorityLevel - 1]
        : { nodeUserList: [], conditionList: [] };
      this.setInit(this.conditionConfig);
    },
    conditionDrawer(val) {
      this.visible = val;
      if (val) {
        this.setInit(this.conditionConfig);
      }
    }
  },
  methods: {
    ...mapMutations('workflow', ['setCondition', 'setConditionsConfig']),
    saveCondition() {
      let needSave = true;
      this.$refs.conditionForm.validate(valid => {
        if (!valid) {
          needSave = false;
        }
      });
      if (!needSave) {
        return false;
      }
      const a = this.conditionsConfig.branchList.splice(
        this.PriorityLevel - 1,
        1
      ); // 截取旧下标
      this.conditionsConfig.branchList.splice(
        this.conditionConfig.priorityLevel - 1,
        0,
        a[0]
      ); // 填充新下标
      this.conditionsConfig.branchList.forEach((item, index) => {
        item.priorityLevel = index + 1;
      });
      const boolSpelExpressionList = getFormatConditionData(
        this.formData.conditionsOr
      );
      const conditionString = this.getStringByConditionArr(
        boolSpelExpressionList
      );
      this.conditionConfig.boolSpelExpression = conditionString;
      this.conditionConfig.boolSpelExpressionList = boolSpelExpressionList;
      for (let i = 0; i < this.conditionsConfig.branchList.length; i++) {
        this.conditionsConfig.branchList[i].error =
          preload.conditionStr(this.conditionsConfig, i) == '请设置条件';
      }
      this.setConditionsConfig({
        value: this.conditionsConfig,
        flag: true,
        id: this.conditionsConfig1.id
      });
      this.setCondition(false);
    },
    addConditionRole() {
      this.conditionRoleVisible = true;
      this.checkedList = this.conditionConfig.nodeUserList;
    },
    sureConditionRole(data) {
      this.conditionConfig.nodeUserList = data;
      this.conditionRoleVisible = false;
    },
    addAnd(item, index) {
      item.push({ keys: '', operator: '', value: '', type: '', multiple: '' });
    },
    addOr() {
      this.formData.conditionsOr.push([
        {
          keys: '',
          operator: '',
          value: null,
          type: '',
          label: '',
          multiple: '',
          optionItems: [],
          dateType: '',
          dateFormat: ''
        }
      ]);
    },
    closeDrawer() {
      this.setCondition(false);
    },
    deleteItem(item, orIndex, andIndex) {
      // 删除的时候有个逻辑，在删除 如果当前的是
      if (this.formData.conditionsOr.length == 1) {
        if (this.formData.conditionsOr[0].length == 1) {
          this.$Message.warning('至少有一个条件');
        } else {
          this.formData.conditionsOr[orIndex].splice(andIndex, 1);
        }
      } else {
        // 如果当前是小最后一个的话，就直接把整个 conditionor 的那一个item 删除就可以了
        const item = this.formData.conditionsOr[orIndex];
        if (item.length <= 1) {
          // 此时删除整个item
          this.formData.conditionsOr.splice(orIndex, 1);
        } else {
          this.formData.conditionsOr[orIndex].splice(andIndex, 1);
        }
      }
    },
    keyChange(value) {
      const {
        type,
        label,
        optionItems = [],
        multiple = '',
        dateType = '',
        dateFormat = ''
      } = this.typeSelect.find(item => item.id == value);
      // 找到对应数据源的选中的type
      this.formData.conditionsOr.forEach(array => {
        array.forEach(item => {
          if (item.keys == value) {
            item.type = type;
            item.label = label;
            item.optionItems = optionItems;
            item.multiple = multiple;
            item.dateType = dateType;
            item.dateFormat = dateFormat;
          }
        });
      });
    },
    getStringByConditionArr(data) {
      const orString = data.map(or => {
        // 先把且拼接 #{money}  > 1000 and #{amunt} < 10
        const andStringArr = or.map(and => {
          const { keys, operator, value, type, multiple } = and;
          if (['in', 'notIn'].includes(operator)) {
            let val = value;
            if (Array.isArray(value)) {
              val = value.map(item => `'${item}'`);
            }
            let returnStr = `#${operator}(#${keys},{${val}})`;
            if (
              type == 'checkbox' ||
              (type == 'select' && multiple == 'multiple')
            ) {
              returnStr = `#${operator}('${val}',#${keys})`;
            }
            return returnStr;
          }
          if (['strContains', 'notStrContains'].includes(operator)) {
            let returnStr = `#${operator}(#${keys},'${value}')`;
            if (['radio'].includes(type)) {
              returnStr = `#${operator}(#'${value}',${keys})`;
            }
            return returnStr;
          }

          let val = type == 'number' ? value : `\'${value}\'`;
          if (Array.isArray(value)) {
            val = value.map(item => `'${item}'`);
          }
          return `#${keys} ${operator} ${val}`;
        });
        const andString = andStringArr.join(' and ');
        return `(${andString})`;
      });
      const useData = orString.join(' or ');
      return useData;
    },
    setInit(nodeConfig) {
      const { boolSpelExpressionList = [] } = nodeConfig;
      if (
        Array.isArray(boolSpelExpressionList) &&
        boolSpelExpressionList.length > 0
      ) {
        this.formData.conditionsOr = [...boolSpelExpressionList];
      } else {
        this.formData.conditionsOr = [
          [
            {
              keys: '',
              operator: '',
              value: null,
              type: '',
              label: '',
              multiple: '',
              optionItems: [],
              dateType: '',
              dateFormat: ''
            }
          ]
        ];
      }
      const newePermissionOption = this.permissionOption.filter(
        i => !this.noShowConditionOption.includes(i.type)
      );
      //  permissionOption  defaultTypeSelect 拼接
      this.typeSelect = [...defaultTypeSelect, ...newePermissionOption];
    },
    validatorValue
  }
};
</script>

<style lang="less">
.condition_copyer {
  .Drawer__body {
    .priority_level {
      position: absolute;
      top: 11px;
      right: 30px;
      width: 100px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(217, 217, 217, 1);
    }
  }

  .condition_content {
    padding: 20px 20px 0;

    p.tip {
      margin: 20px 0;
      width: 510px;
      text-indent: 17px;
      line-height: 45px;
      background: rgba(241, 249, 255, 1);
      border: 1px solid rgba(64, 163, 247, 1);
      color: #46a6fe;
      font-size: 14px;
    }

    ul {
      max-height: 500px;
      overflow-y: scroll;
      margin-bottom: 20px;

      li {
        & > span {
          float: left;
          margin-right: 8px;
          width: 70px;
          line-height: 32px;
          text-align: right;
        }

        & > div {
          display: inline-block;
          width: 370px;

          & > p:not(:last-child) {
            margin-bottom: 10px;
          }
        }

        &:not(:last-child) > div > p {
          margin-bottom: 20px;
        }

        & > a {
          float: right;
          margin-right: 10px;
          margin-top: 7px;
        }

        select,
        input {
          width: 100%;
          height: 32px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid rgba(217, 217, 217, 1);
        }

        select + input {
          width: 260px;
        }

        select {
          margin-right: 10px;
          width: 100px;
        }

        p.selected_list {
          padding-left: 10px;
          border-radius: 4px;
          min-height: 32px;
          border: 1px solid rgba(217, 217, 217, 1);
          word-break: break-word;
        }

        p.check_box {
          line-height: 32px;
        }
      }
    }

    .Button {
      margin-bottom: 20px;
    }
  }
}

.condition_list {
  .el-dialog__body {
    padding: 16px 26px;
  }

  p {
    color: #666666;
    margin-bottom: 10px;

    & > .check_box {
      margin-bottom: 0;
      line-height: 36px;
    }
  }
}
.andClass {
  margin: 5px 0;
}
</style>
